import { render, staticRenderFns } from "./delete-company.vue?vue&type=template&id=f89f450e&scoped=true&"
import script from "./delete-company.vue?vue&type=script&lang=js&"
export * from "./delete-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89f450e",
  null
  
)

export default component.exports